import type { APIWithPagination, DeepQueryParams, SWRConfigInterface } from '@gik/core/api/BaseAPIConfig';
import { wpApi } from '@gik/core/api/ky/wpApi';
import { useWPApi } from '@gik/core/api/swr/useWPApi';
import type WordpressPost from '@gik/core/models/wordpress/WordpressPost';
import PostsUrlBuilder from './PostsUrlBuilder';

const path = 'posts';

export interface GeneralResultsParams extends APIWithPagination {
  pageSlug?: string; // TODO: add strong typings
  taxonomySlug?: string; // TODO: add strong typings
}

function getParams(params: GeneralResultsParams): DeepQueryParams {
  const builder = new PostsUrlBuilder();

  if (params?.pageSlug == 'being-supportive') {
    builder.withSingleTaxonomyMultipleItems({
      taxonomy: params?.taxonomySlug,
      terms: [params?.pageSlug, 'editorial', 'buying-guide'],
    });
  } else {
    builder.withSingleTaxonomyItem({
      taxonomy: params?.taxonomySlug,
      terms: params?.pageSlug,
    });
  }
  builder.orderedByPriority().withAllPages();

  return builder.params;
}

export function getGeneralResults(params: GeneralResultsParams) {
  return wpApi
    .get(path, {
      searchParams: getParams(params),
    })
    .json<WordpressPost[]>();
}

export function useGeneralResults(params: GeneralResultsParams, config?: SWRConfigInterface) {
  return useWPApi<WordpressPost[]>(params?.taxonomySlug && params?.pageSlug ? path : null, getParams(params), config);
}
